"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = addScript;
const forEach_1 = __importDefault(require("../object/forEach"));
function appendScript({ src, id, async = false, attributes = {}, appendTo = 'body', }) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = async;
        script.src = src;
        (0, forEach_1.default)(attributes, (value, key) => {
            script.setAttribute(key, value);
        });
        script.onload = resolve;
        script.onerror = reject;
        if (id) {
            script.id = id;
        }
        document[appendTo].appendChild(script);
    });
}
function scriptExists(src) {
    return Boolean(document.querySelector(`script[src="${src}"]`));
}
async function addScript(options) {
    const { src } = options;
    if (!scriptExists(src)) {
        await appendScript(options);
    }
}
